import React from "react";
import { DeviceUnknownOutlined } from "@mui/icons-material";

/**
 * Get default/fallback icon for unknown widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getDefaultIcon = (widget = null) => {
  const iconProps = {
    sx: { fontSize: "1.5rem", pb: "2px" },
  };

  return <DeviceUnknownOutlined {...iconProps} />;
};
